import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CampaignDatesService {
  private startDateSubject = new BehaviorSubject<Date | null>(null);
  private endDateSubject = new BehaviorSubject<Date | null>(null);

  public startDate$ = this.startDateSubject.asObservable();
  public endDate$ = this.endDateSubject.asObservable();

  public setStartDate(date: Date): void {
    this.startDateSubject.next(date);
  }

  public setEndDate(date: Date): void {
    this.endDateSubject.next(date);
  }
}
